module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-text rellax",
    attrs: {
      "data-rellax-speed": "1"
    }
  }, [_c('span', {
    staticClass: "main-header-headline"
  }, [_vm._v(_vm._s(_vm.headerText))]), _vm._v(" "), _c('span', {
    staticClass: "main-header-body"
  }, [_vm._v(_vm._s(_vm.subheaderText))])]), _vm._v(" "), _c('div', {
    staticClass: "header-logos"
  }, _vm._l((_vm.logos), function(brand) {
    return _c('img', {
      staticClass: "header-brand-logo",
      attrs: {
        "src": _vm.getImgUrl(brand)
      }
    })
  }), 0)]), _vm._v(" "), _vm._l((_vm.pageData.demos), function(demo) {
    return _c('div', {
      staticClass: "vertical-page-demo-block",
      style: (("background-color: " + (demo.backgroundColor)))
    }, [(demo.orientation == 'left') ? _c('span', {
      staticClass: "vertical-inline-element"
    }, [_c('PhoneAndVideoComponent', {
      attrs: {
        "demo": demo
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "vertical-inline-element desktop-element vertical-element-details"
    }, [_c('div', {
      staticClass: "vertical-attach-type-used"
    }, [_vm._v("\n        Attach "), _c('span', {
      class: ("attach-product-badge badge-for-" + (demo.attachProduct))
    }, [_vm._v(_vm._s(demo.attachProduct))])]), _vm._v(" "), _c('div', {
      staticClass: "vertical-element-headline",
      domProps: {
        "innerHTML": _vm._s(demo.headline)
      }
    }), _vm._v(" "), _vm._l((demo.text), function(textItem) {
      return _c('div', {
        staticClass: "vertical-element-text",
        domProps: {
          "innerHTML": _vm._s(textItem)
        }
      })
    }), _vm._v(" "), _c('ul', {
      staticClass: "vertical-element-text"
    }, _vm._l((demo.bullets), function(bullet) {
      return _c('li', {
        staticClass: "vertical-element-bullet",
        domProps: {
          "innerHTML": _vm._s(bullet)
        }
      })
    }), 0), _vm._v(" "), _c('a', {
      staticClass: "attach-item-request-demo-button",
      attrs: {
        "href": "#contact-footer"
      },
      on: {
        "click": function($event) {
          return _vm.clickedRequestDemoButton(demo)
        }
      }
    }, [_vm._v("Request a demo")])], 2), _vm._v(" "), (demo.orientation == 'right') ? _c('span', {
      staticClass: "vertical-inline-element"
    }, [_c('PhoneAndVideoComponent', {
      attrs: {
        "demo": demo
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "vertical-inline-element mobile-element vertical-element-details"
    }, [_c('div', {
      staticClass: "vertical-attach-type-used"
    }, [_vm._v("\n        Attach "), _c('span', {
      class: ("attach-product-badge badge-for-" + (demo.attachProduct))
    }, [_vm._v(_vm._s(demo.attachProduct))])]), _vm._v(" "), _c('div', {
      staticClass: "vertical-element-headline",
      domProps: {
        "innerHTML": _vm._s(demo.headline)
      }
    }), _vm._v(" "), _vm._l((demo.text), function(textItem) {
      return _c('div', {
        staticClass: "vertical-element-text",
        domProps: {
          "innerHTML": _vm._s(textItem)
        }
      })
    }), _vm._v(" "), _c('a', {
      staticClass: "attach-item-request-demo-button",
      attrs: {
        "href": "#contact-footer"
      },
      on: {
        "click": function($event) {
          return _vm.clickedRequestDemoButton(demo)
        }
      }
    }, [_vm._v("Request a demo")])], 2)])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8a0d35f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/AttachVerticalHeaderComponent/AttachVerticalHeaderComponent.vue
// module id = 495
// module chunks = 0